<template>
    <div class="fwpj">
        <div class="title">
            <span>服务评价</span> 
                <div class="close">
                    <el-button type="text" icon="el-icon-close" @click="close()" ></el-button>
                </div>
        </div>
        <div class="text">
            <div v-if="success" class="success-tip">
                <my-tag type="success">感谢您的评价，我们会继续努力给您带来更优质的服务！</my-tag>
            </div> 
            <div >
                尊敬的用户：
            </div>
            <div class="wenhou">
                您好，为了更好的推进我们的服务工作，特邀请您对于在发标及开评标阶段我司工作人员的服务表现进行评价，您的评价对我们非常重要，烦请您如实填写，谢谢您的理解。
            </div>
            <div class="fw">
                <div class="left">
                    服务评价
                </div>
                <div class="right">
                    满意请给5星哦
                </div>
            </div>
            <div class="fbjd">
                <div class="fabiao">
                    <span>
                       发标阶段 
                    </span>
                 
                        <my-tag type="danger" v-if="fbbqtishi==true" class="fbbqtishi">
                            不满意？请选择标签。
                        </my-tag>
                                
                <my-tag type="danger" v-if="fbtip" class="fbtip"> 请您对发标阶段我公司工作人员进行评价！</my-tag>
                </div> 
                
      
                  
                <div class="rate">
                    <el-rate v-model="fbcurScore"  :texts="texts" show-text @change="fbchangeScore()" ></el-rate>

                </div>
                <div class="xuanxiang" v-if="fbcurScore<=3&&fbxianshi==true">
                    <ul class="box" >
                        <li v-for="(item,index) of fbitems"
                            :class="{checked:item.bOn}"
                            @click="checkbox(index)" :key = "index">{{item.name }}
                        </li>
                    </ul>
                 
                    <!-- <el-input 
                        v-model="qita" 
                        type="textarea" 
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="
                        请填写在发标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                        v-if="fbqita==true">
                    </el-input> -->
                    <el-input
                        v-model="qita" 
                        type="textarea"
                        :autosize="{ minRows: 2}"       
                        placeholder="请填写在发标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                        v-if="fbqita==true"
                        :class="{xianzhi:fbqitatip==true&&enter<2}"
                        maxlength="400" @input="descInput" show-word-limit
                        @blur="showfabiao($event)">
                    </el-input>               
    

                    <span class="gray" v-if="fbqitatip==true&&enter<2&&fbqita==true">内容不少于2个字</span>
                </div>
            </div>

            <div class="kpbjd">
                <div class="fabiao"> 
                    开评标阶段
                    <my-tag type="danger" class="kpbbqtishi" v-if="kpbbqtishi==true">
                    不满意？请选择标签。
                </my-tag>
          
                
                    <my-tag type="danger" v-if="kpbtip" class="kpbtip"> 请您对开评标阶段我公司工作人员进行评价！</my-tag>
                </div>
            
                
              
                <div class="rate">
                    <el-rate  v-model="kpbcurScore" :texts="kpbtexts" show-text  @change="kpbchangeScore()" ></el-rate>
                </div>
                <div  class="xuanxiang" v-if="kpbcurScore<=3&&kpbxianshi==true">
                    <ul class="boxkpb" >
                        <li v-for="(item,index) of kpbitems"
                            :class="{checked:item.bOn}"
                            @click="checkkpbbox(index)" :key = "index">{{item.name }}
                        </li>
                    </ul>
                   
                    <el-input 
                    v-model="kpb_qita" 
                    type="textarea" 
                    :autosize="{ minRows: 2}"
                    placeholder="请填写在开评标阶段遇到的问题，这将帮助我们为您提供更好的服务..."
                    v-if="kpbqita==true"
                   :class="{xianzhi:kpbenter<2&&kpbqitatip==true}"
                    maxlength="400"
                    @input="kpbdescInput" show-word-limit
                    @blur="showkpbiao($event)"
                    >
                    </el-input>
                </div>

         
                 <span class="gray" v-if="kpbenter<2&&kpbqitatip==true&&kpbqita==true&&kpbcurScore<=3">内容不少于2个字</span>
          
                <div class="beizhu" v-if="((fbcurScore>0&&fbcurScore<=3)||(kpbcurScore>0&&kpbcurScore<=3))&&(kpbxianshi==true||fbxianshi==true)">
                     
                    <el-radio v-model="radio" @click.native.prevent="clickitem(3)" :label="3">需要客服联系我，了解服务过程的详细情况！</el-radio>
                    <div v-if="radio===3" class="xianshi">
                    <!-- <span>
                        电话号码：    
                    </span> -->
                    <div class="dhhm">
                        <el-form label-width="80px" >
                            <el-form-item label="电话号码" prop="phonenumber">
                                <el-input v-model="phonenumber" clearable @blur="show($event)" :class="{bk:dianhuatip==true}"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="lxfs" v-if="dianhuatip==true">请填写电话号码</div>
                    </div>
                    </div>
                
                    
                </div>
                <el-button type="danger" class="submit" :disabled="disabled" @click="submit()">提交</el-button>
            </div>
            
        </div>
    </div>
</template>
 
<script>
 
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
		xianshi: {
			type: Boolean,
			default: false
		},
        bdcode: {
			type: String,
			default: ''
		},
        bdname: {
			type: String,
			default: ''
		},
        zbprocode: {
			type: String,
			default: ''
		},
        zbproname: {
			type: String,
			default: ''
		},
        way: {
			type: String,
			default: ''
		},
	},

    data() {
        return{
            kpbqitatip:false,
            fbqitatip:false,
            disabled:false,
            submitLock: false,
            dianhuatip:false,
            fbtip:false,
            kpbtip:false,
            dhtishi:false,
            enter:0,
            kpbenter:0,
            texts: ['非常差', '差', '一般', '满意', '非常满意'],
            kpbtexts:['非常差', '差', '一般', '满意', '非常满意'],
            pjxianshi:false,
            istrue_fb:0,
            istrue_kpb: 0,
            fbcurScore:0,
            kpbcurScore:0,
            fbList:[],
            kpbList:[],
            qita:'',
            fbservicescore:{
                jdlabel:'',
                jdscore:0,
                jdtype:'',
                jdcontent:'',
                jdcontentdetail:'',
                bdcode:'',
           
            },
            kpbservicescore:{
                jdlabel:'',
                jdscore:0,
                jdtype:'',
                jdcontent:'',
                jdcontentdetail:'',
                bdcode:'',
          
            },
            success:false,
          
            kpb_qita:'',
            fbbqtishi:false,
            kpbbqtishi:false,
            fbxianshi:'',
            kpbxianshi:'',
            fbqita:'',
            kpbqita:'',
            // score:2,
            kpbitems: [
                {name:'开标支持迟到',bOn:false},
                {name:'长时间玩手机',bOn:false},
                {name:'缺乏沟通',bOn:false},
                {name:'态度不端正',bOn:false},
                {name:'擅自离岗',bOn:false},
                {name:'专业能力弱',bOn:false},
                {name:'其他',bOn:false},
            ],
            fbitems: [
                {name:'问题回答不专业',bOn:false},
                {name:'演示不熟练',bOn:false},
                {name:'解决问题能力弱',bOn:false},
                {name:'态度恶劣',bOn:false},
                {name:'其他',bOn:false},
            ],
            radio: '',
            phonenumber:'',
            fb_checklist:[],
            
          
           
           
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        show(event) {
            console.log(this.phonenumber)
            if(this.phonenumber=='') {
                this.dianhuatip=true
            }
            else {
                this.dianhuatip=false
            }
            console.log(1)
        },
        showfabiao() {
            console.log(this.qita)
            if(this.qita.length<2) {
                this.fbqitatip=true
            }
            else {
                this.fbqitatip=false
            }
            console.log(1)
        },
        showkpbiao() {
            console.log(this.qita)
            if(this.kpb_qita.length<2) {
                this.kpbqitatip=true
            }
            else {
                this.kpbqitatip=false
            }
            console.log(1)
        },
        kpbdescInput() {
            var txtVal = this.kpb_qita.length;
            this.kpbenter = txtVal;
        },
        descInput() {
            var txtVal = this.qita.length;
            this.enter = txtVal;
        },
        checkMobile :(rule, value, cb) => {
            // 验证手机号的正则表达式
            const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
            if (regMobile.test(value)) {
               return cb()
            }
            cb(new Error('请输入合法的手机号'))
        },
        checkbox(i){
            this.fbbqtishi=false
            this.fbservicescore.jdlabel='发标阶段'
            this.fbservicescore.jdtype='1'
            this.fbqita=false
            this.fbList=[]
            this.fbitems[i].bOn = !this.fbitems[i].bOn;
            var that=this
            this.fbitems.forEach(function(item){
                if(item.bOn==true) {
                    that.fbList.push(item)    
                }               
            })
            var fbname=[]
            console.log(this.fbList)
            if(this.fbList.length==0) {
                 this.fbservicescore.jdcontent=''
            }
            this.fbList.forEach(function(item){   
             
                fbname.push(item.name)
                that.fbservicescore.jdcontent=fbname.join(',')
                if(item.name=='其他') {
                    that.fbqita=true
                }          
            })
            this.fbservicescore.jdcontentdetail=this.qita
             console.log(this.fbservicescore.jdcontent)
             
        },
        checkkpbbox(i){
            this.kpbbqtishi=false
            this.kpbservicescore.jdlabel='开评标阶段'
            this.kpbservicescore.jdtype='2'
            this.kpbqita=false
            this.kpbList=[]
            this.kpbitems[i].bOn = !this.kpbitems[i].bOn;
            var that=this
            this.kpbitems.forEach(function(item){
                if(item.bOn==true) {
                    that.kpbList.push(item)
                    
                }
            })
            var kpbname=[]
            if(this.kpbList.length==0) {
                 this.kpbservicescore.jdcontent=''
            }
            this.kpbList.forEach(function(item){
             
                kpbname.push(item.name)
                that.kpbservicescore.jdcontent=kpbname.join(',')
                if(item.name=='其他') {
                   that.kpbqita=true
                }
            })
            this.kpbservicescore.jdcontentdetail=this.kpb_qita
           console.log(this.kpbservicescore.jdcontent)
        },
        close(){
            this.pjxianshi=false
            this.$emit('close',this.pjxianshi)
        },
        clickitem (e) {
            e === this.radio ? this.radio = '' : this.radio= e  
        },
        fbchangeScore(){
            this.fbtip=false
            this.fbservicescore.jdtype='1'
            this.fbservicescore.jdlabel='发标阶段'
            this.fbservicescore.bdcode=this.bdcode
            this.fbxianshi=true
            if(this.fbcurScore>3) {
                this.fbbqtishi=false
            }
            this.$nextTick(() => {
                this.fbservicescore.jdscore=this.fbcurScore
            })
        },
        kpbchangeScore(){
            this.kpbtip=false
            this.kpbservicescore.jdlabel='开评标阶段'
            this.kpbservicescore.bdcode=this.bdcode
            this.kpbservicescore.jdtype='2'
            this.kpbxianshi=true
            if(this.kpbcurScore>3) {
                this.kpbbqtishi=false
            }
            this.$nextTick(() => {
                         
                this.kpbservicescore.jdscore=this.kpbcurScore
                if(this.kpbservicescore.jdscore>=3.5) {
                    this.radio=''
                }
            })
         
        },
        submit() {
            this.disabled=true
            // this.submitLock = true;
            setTimeout(function () {
                this.disabled = false;
            }.bind(this),3000);
            console.log(this.qita=='')
           
        //    if(this.fbcurScore==0||this.kpbcurScore==0)
            if(this.fbcurScore==0&&this.kpbcurScore==0) {
                this.fbtip=true
                this.kpbtip=true
                return
            }
            if(this.fbcurScore>0&&this.fbcurScore<=3&&this.fbservicescore.jdcontent=='') {
                this.fbbqtishi=true
            }
            if(this.fbcurScore>0&&this.fbcurScore<=3&&this.qita==''&&this.fbqita==true) {
                this.fbqitatip=true
            }
            if(this.kpbcurScore>0&&this.kpbcurScore<=3&&this.kpbservicescore.jdcontent=='') {
                this.kpbbqtishi=true
            }
            if(this.kpbcurScore>0&&this.kpbcurScore<=3&&this.kpb_qita==''&&this.kpbqita==true) {
                
                this.kpbqitatip=true
            }
            if(this.fbcurScore==0) {
                this.fbtip=true
                return
            }
            if(this.kpbcurScore==0) {
                this.kpbtip=true
                return
            }
            
            console.log(this.kpbservicescore.jdcontent)
            console.log(this.fbservicescore.jdcontent)
            if(this.kpbcurScore<=3&&this.kpbservicescore.jdcontent==''&&this.fbcurScore<=3&&this.fbservicescore.jdcontent=='') {
                this.fbbqtishi=true
                this.kpbbqtishi=true
            }
            if(this.kpbcurScore<=3&&this.kpbservicescore.jdcontent=='') {
                this.kpbbqtishi=true
                return
            }
            if(this.fbcurScore<=3&&this.fbservicescore.jdcontent=='') {
                this.fbbqtishi=true
                return
            }
             
            // if(this.fbqita==true&&this.qita=='') {
            //     this.fbqitatip=true
            //     return
            // }
            if(this.qita==''&&this.fbqita==true&&this.kpbqita==true&&this.kpb_qita==''&&this.fbcurScore<=3&&this.kpbcurScore<=3) {
                this.fbqitatip=true
                this.kpbqitatip=true
                return
            }
            if(this.qita==''&&this.fbqita==true&&this.fbcurScore<=3) {
                this.fbqitatip=true
                console.log(this.enter<2)
                
                console.log(this.enter)
                return
            }
            if(this.kpb_qita==''&&this.kpbqita==true&&this.kpbcurScore<=3) {
                
                this.kpbqitatip=true
                 return
            }
            // if((this.qita==''&&this.fbqita==true)||(this.kpb_qita==''&&this.kpbqita==true)) {
            //     return
            // }
            console.log(1)
             console.log(this.kpbservicescore.jdcontent)
            if((this.fbservicescore.jdcontent==''&&this.fbcurScore<=3)||(this.kpbservicescore.jdcontent==''&&this.kpbcurScore<=3)) {
                    this.bqtishi=true
                    return
            }
            if(this.radio==3&&this.phonenumber=='') {
                this.dianhuatip=true
                return 
            }
            if(this.radio=='') {
                this.phonenumber=''
            }
            // if((this.fbcurScore<3&&this.fbservicescore.jdcontent!=='')||(this.this.kpbcurScore<3&&this.fbservicescore.jdcontent!==''))
            this.fbqitatip=false
            this.kpbqitatip==false
            this.dianhuatip=false
            this.fbbqtishi=false
            this.kpbbqtishi=false
            this.bqtishi=false
            this.success=true
            this.kpbtip=false
            this.fbtip=false
            
            this.fbservicescore.jdcontentdetail=this.qita
            this.kpbservicescore.jdcontentdetail=this.kpb_qita
            if(this.fbcurScore>3) {
                this.fbservicescore.jdcontent=''
                this.fbservicescore.jdcontentdetail=''
            }
            if(this.kpbcurScore>3) {
                this.kpbservicescore.jdcontent=''
                this.fbservicescore.jdcontentdetail=''
            }
            if(this.fbqita==false) {
                this.fbservicescore.jdcontentdetail=''
            }
            if(this.kpbqita==false) {
                this.kpbservicescore.jdcontentdetail=''
            }
          
            var that=this
                             console.log({
            zbprocode:this.zbprocode,
 zbproname:this.zbproname,
 bdcode:this.bdcode,
 bdname:this.bdname,

 t_servicescorejd:[
     this.fbservicescore,this.kpbservicescore
 ] })
            // this.$message({
            //     message: '恭喜你，这是一条成功消息',
            //     type: 'success',
            //     center: true
            // });
            setTimeout(function () {
            //     if(that.radio==3&&that.phonenumber!=='') {
            //     that.$refs[formName].validate((valid) => {
            //         if (valid) {
            //             that.$post(`${that.getGetters('mngUrl')}/service/pj/addOreditpj.json`,{
            //                 zbprocode:that.zbprocode,
            //                 zbproname:that.zbproname,
            //                 bdcode:that.bdcode,
            //                 bdname:that.bdname,
            //                 phone:that.phonenumber,
            //                 t_servicescorejd:[
            //                     that.fbservicescore,that.kpbservicescore
            //                 ]
            //             }, (data, res) => {
            //             ShowMsg(res.msg) 
            //             that.$nextTick(() => {
            //                 that.pjxianshi=false
            //                 that.$emit('close',that.pjxianshi)
            //                             })
            //             },true); 
            //         } 
            //         else {
            //             return false;
            //         }
            //     }); 
            // }
         
    //                 console.log({
    //            zbprocode:this.zbprocode,
    // zbproname:this.zbproname,
    // bdcode:this.bdcode,
    // bdname:this.bdname,
    // phone:this.ruleForm.phonenumber,
    // t_servicescorejd:[
    //     this.fbservicescore,this.kpbservicescore
    // ] })
                that.$post(`${that.getGetters('mngUrl')}/service/pj/addOreditpj.json`,{
                    zbprocode:that.zbprocode,
                    zbproname:that.zbproname,
                    bdcode:that.bdcode,
                    bdname:that.bdname,
                    phone:that.phonenumber,
                    t_servicescorejd:[
                        that.fbservicescore,that.kpbservicescore
                    ]
                    }, (data, res) => {
                        ShowMsg(res.msg) 
                        that.$nextTick(() => {
                            that.pjxianshi=false
                            that.$emit('close',that.pjxianshi)
    //    this.reloadHandler()
                        })
            
                    },true);
            
            }, 2000);
            
        }
    },
    created() {

     
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

.fwpj {
    width: 47%;
    height: 90%;
    margin: auto;
    // background-color: rgb(197, 184, 184);
    border-radius: 5px;
    position: fixed;
    top: 29px;
    z-index: 3000;
    left: 30%;
    background-color: #fff
}
.fw {
    width: 100%;
    margin-bottom: 3%;
    height: 20px;
}
.title {
    height: 45px;
    line-height: 45px;
    color: #fff;
    // float: left;
    padding-left: 10px;
    background-color: rgba(251, 115, 98, 1);
}
.text {
    padding:2%;
    font-size: 14px;
    height: 88%;
    width: 95%;
    overflow: auto;
    // letter-spacing:0px;
}
.wenhou {
    margin-top:10px;
    text-indent:28px;
    margin-bottom:5%;
}
.left {
    float: left;
    font-weight: 700;
    margin-bottom: 10px;
    // width: 100%;

}
.right {
    float: right;
    color: #7F7F7F;
     margin-bottom: 10px;
}
.kpbjd {
    margin-bottom: 10px;
    margin-top: 2%;
}
.kpbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    }
.kpbjd  ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    width: 15%;
    padding: 1%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }
.kpbjd ul {
    margin-bottom: 10px;
    }
.fbjd ul li {
    float: left;
    margin-right: 3%;
    margin-bottom: 1%;
    list-style-type: none;
    padding: 1%;
    width: 15%;
    line-height: 30px;
    text-align: center;
    background: inherit;
    border-radius: 10px;
    cursor: pointer;
    background-color: rgba(242, 242, 242, 1);
    }   
.fbjd .active {
    background-color: rgba(251, 115, 98, 1);
    color: #fff
    } 
.fbjd {
    font-size:14px;
    // height: 169px;
    // margin-bottom: 70px;
    }
.dhhm {
    width: 45%;
    margin-right: 30%;
    float: left;
    position: relative;
    }
.xuanxiang {
    width: 100%;
    padding-bottom: 1%;
 
}
.lxfs {
    color: #ec0404;
    float: left;
    position: absolute;
    left: 23%;
    top: 68%;
    font-size: 14px;
}
.xianshi {
    margin-top: 10px;
}
ul{
    padding:0; 
    list-style:none;
}
.box {
    width: 100%;
}
.boxkpb {
    height:100px ;
}
.box .checked{ 
    background-color: rgba(251, 115, 98, 1);
    color: #fff}
.boxkpb .checked{ 
background-color: rgba(251, 115, 98, 1);
color: #fff}
.submit {
    margin-top: 6%;
    margin-left: 45%;
}
.close {
    margin-right: 10px;
    float: right;
}
/deep/.el-icon-close {
    color: #333333;
    font-size: 25px;
}
.kai {
    margin-bottom: 15px;
}
.beizhu {
    // margin-top:12%;
}
/deep/ .radio {
    padding-top: 4%;
}
.fabiao {
    margin-bottom: 1%;
}
/deep/ .el-rate__icon {
    font-size:40px;
}
.rate {
    height:45px;
    margin-bottom: 10px;
}
.success-tip {
    position: fixed;
    top: 40%;
    left: 45%;
    z-index: 3500;
}
.el-tag.el-tag--success {
    font-size: 14px;
}
.gray {
    color:rgb(236, 4, 4)
}
/deep/ .xianzhi .el-textarea__inner {
    border-color: rgb(236, 4, 4);
}
// /deep/ .el-message {
//     top: 41%!important;
//     left: 56%!important;
//     z-index: 3350!important;
// }
/deep/.success-tip .reason {
    white-space: pre-wrap;
    height: 100px;
    line-height: 100px;
    z-index: 3500;
} 
/deep/ .bk .el-input__inner {
        border: 1px solid #ec0404;
}
/deep/ .el-tag {
    font-size: 14px;
}
</style>
